<template>
  <div>
    <v-card class="mt-3" :class="modalClasses">
      <v-card-title class="py-0 pb-1">
        
        <v-btn icon>
          <v-icon small>fa-solid fa-bars</v-icon>
        </v-btn>
        <img v-if="isDarkMode" class="mx-2" src='/img/bot-midgray2-white.png' style="height: 30px;" alt="">
        <img v-else class="mx-2" src='/img/bot-gray2-dark.png' style="height: 30px;" alt="">
        <span style="color: var(--v-mid-grey2-base)">Ask AVA </span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="clear"> <v-icon small>fa-light fa-rotate-right</v-icon></v-btn>
        <v-btn icon small @click="maximize"> <v-icon small>{{ maximized?'mdi-arrow-collapse':'mdi-arrow-expand' }} </v-icon></v-btn>
        <v-btn icon small @click="close"> <v-icon small>fa-solid fa-xmark</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: calc(100% - 120px);">
        <div class="chat-body">
          <div v-for="message in messages" :key="message.id">
         <chatbot-message :message="message"></chatbot-message>
          </div>
        </div>
      </v-card-text>
      <div style="height:120px"></div>
      <div class="input-area">
          <v-text-field rounded v-model="message" @keydown="keyDown" class="mr-2" outlined v-virtual-keyboard hide-details="" placeholder="Enter your query here..."
            style="flex-grow: 1;">
            <template v-slot:append>
              <v-btn rounded color="primary"  class="send-btn"  @click="sendMessage" :loading="loading" :disabled="loading||!message">Send</v-btn>
            </template>
          
          </v-text-field>
          
        </div>
    </v-card>
  </div>
</template>

<script>
import { log, warn, error } from '@/utils/debugLogger';
import { $uuidv4 } from '@/utils';
import { mapGetters } from 'vuex';
import ChatApi from '../services/chatbot.service';
import ChatbotMessage from './chatbot-message.vue';
export default {
  components: {   ChatbotMessage },
data(){
  return{
    opened:false,
    maximized:false,
    message:'',
    loading:false,
    threadId:null,
    messages:[
    { 
      id:1,
        role:'assistant',
        content:'Hello, How I could help you today?',
        messageType:'query',
      },
//       {
//     "role": "assistant",
//     "content": null,
//     "messageType": "ViewerAction",
//     "query": null,
//     "action": ` const { forgeService } = store;
//   forgeService.openTagIn3dAnd360({ name: 'BD-501185-1"-EA3DY' });  `,
//     "title": null,
//     "subTitle": null,
//     "hasErrors": false,
//     "errorMessage": null,
//     "id": "e6b2decf-7949-473a-8e36-e2b319f76f5b",
//     "createDate": "2025-05-14T01:28:43.2188053Z",
//     "updateDate": null,
//     "createdBy": null,
//     "updatedBy": null
// }
      // {
      //   id:2,
      //   role:'assistant',
      //   messageType:'pie',
      //   title:'Tasks by Task Statuses',
      //   subTitle:'Tasks grouped by Task Statuses for the current asset',
      //   query:'SELECT [ts].[Name] AS [label], COUNT([t].[Id]) AS [value] FROM [Tasks] [t] JOIN [TaskStatuses] [ts] ON [t].[StatusId] = [ts].[Id] WHERE [t].[IsDeleted] = 0 AND [ts].[IsDeleted] = 0 GROUP BY [ts].[Name]',
      //   content:"[{\"Label\":\"Backdraft\",\"Value\":2},{\"Label\":\"Cancelled\",\"Value\":4},{\"Label\":\"Client Backdraft\",\"Value\":1},{\"Label\":\"Closed Out\",\"Value\":3},{\"Label\":\"Close-Out\",\"Value\":1},{\"Label\":\"Complete\",\"Value\":13},{\"Label\":\"Completed\",\"Value\":3},{\"Label\":\"Design\",\"Value\":3},{\"Label\":\"Design & Procurement\",\"Value\":4},{\"Label\":\"Fabricated\",\"Value\":1},{\"Label\":\"In Progres\",\"Value\":2},{\"Label\":\"In Progress\",\"Value\":7},{\"Label\":\"Initiation\",\"Value\":4},{\"Label\":\"Installed\",\"Value\":11},{\"Label\":\"Issued to Client\",\"Value\":1},{\"Label\":\"Not Started\",\"Value\":45},{\"Label\":\"Offshore\",\"Value\":28},{\"Label\":\"Overdue\",\"Value\":2},{\"Label\":\"Positioned\",\"Value\":2},{\"Label\":\"Procurement\",\"Value\":5},{\"Label\":\"Ready for QA\",\"Value\":2},{\"Label\":\"Report Assigned\",\"Value\":2},{\"Label\":\"Report In Progress\",\"Value\":2},{\"Label\":\"Survey Complete\",\"Value\":1},{\"Label\":\"To Do\",\"Value\":8},{\"Label\":\"Verified\",\"Value\":5}]"
      // },
      // {
      //   id:3,
      //   role:'assistant',
      //   messageType:'table',
      //   title:'Tasks by Task Statuses',
      //   subTitle:'Tasks grouped by Task Statuses for the current asset',
      //   query:'SELECT [ts].[Name] AS [label], COUNT([t].[Id]) AS [value] FROM [Tasks] [t] JOIN [TaskStatuses] [ts] ON [t].[StatusId] = [ts].[Id] WHERE [t].[IsDeleted] = 0 AND [ts].[IsDeleted] = 0 GROUP BY [ts].[Name]',
      //   content:"[{\"Label\":\"Backdraft\",\"Value\":2},{\"Label\":\"Cancelled\",\"Value\":4},{\"Label\":\"Client Backdraft\",\"Value\":1},{\"Label\":\"Closed Out\",\"Value\":3},{\"Label\":\"Close-Out\",\"Value\":1},{\"Label\":\"Complete\",\"Value\":13},{\"Label\":\"Completed\",\"Value\":3},{\"Label\":\"Design\",\"Value\":3},{\"Label\":\"Design & Procurement\",\"Value\":4},{\"Label\":\"Fabricated\",\"Value\":1},{\"Label\":\"In Progres\",\"Value\":2},{\"Label\":\"In Progress\",\"Value\":7},{\"Label\":\"Initiation\",\"Value\":4},{\"Label\":\"Installed\",\"Value\":11},{\"Label\":\"Issued to Client\",\"Value\":1},{\"Label\":\"Not Started\",\"Value\":45},{\"Label\":\"Offshore\",\"Value\":28},{\"Label\":\"Overdue\",\"Value\":2},{\"Label\":\"Positioned\",\"Value\":2},{\"Label\":\"Procurement\",\"Value\":5},{\"Label\":\"Ready for QA\",\"Value\":2},{\"Label\":\"Report Assigned\",\"Value\":2},{\"Label\":\"Report In Progress\",\"Value\":2},{\"Label\":\"Survey Complete\",\"Value\":1},{\"Label\":\"To Do\",\"Value\":8},{\"Label\":\"Verified\",\"Value\":5}]"
      // }
    ]
  }
},
methods:{
  open(){
    this.opened=true;
  },
  close(){
    this.opened=false;
    this.maximized=false;
  },
  maximize(){
    this.maximized=!this.maximized;
  },
  clear(){
    this.messages=[ { 
      id:1,
        role:'assistant',
        content:'Hello, How I could help you today?',
        messageType:'query',
      }],
      this.threadId=null;
      this.getThreadId();
  },
  keyDown(event){
    if (event.key === "Enter" ) {
    event.preventDefault(); // Optional: prevent newline if in textarea
    this.sendMessage();
    // ✅ Call your action here
  }
  },
  getContextData(){
   var facilityId= this.$route.params.id;
   return JSON.stringify({facilityId});
  },
  sendMessage(){
    this.loading=true;
    var payload={
      id:$uuidv4(),
      role:'user',
      content: this.message,
      contextData:this.getContextData(),
      threadId:this.threadId
    };
    this.messages.push(payload);
    this.message=null;
    var response={
      id:$uuidv4(),
      role:'thinking',
      content:''
    }
  
     var toBeSent=structuredClone(this.messages);
     toBeSent.forEach(msg=>{
      if(msg.messageType!='query'){
          msg.content=JSON.stringify(msg.content);
      }
     });
    ChatApi.generateList(toBeSent).then(res=>{
      this.messages.splice(-1);
      this.messages.push(res.data);
    }).finally(()=>{
      this.loading=false;
    });
    
    setTimeout(()=>{
      this.messages.push(response);
    },300);
    
  },
  getThreadId(){
    ChatApi.getThreadId().then(res=>{
    this.threadId=res.data.threadId
  }).catch(err=>{
    log(err);
  }).finally({

  })
  }
},
computed:{
 
  isDarkMode: {
    get() {
          return this.$store.getters['SETTING/GET_DARK_MODE'];
        }
     
  },
  modalClasses(){
    if (this.opened) {
      if (this.maximized)
        return ['chatbot-modal', 'open', 'max']
      else
        return ['chatbot-modal', 'open']
    }
  
  else
  return ['chatbot-modal']
  },
  ...mapGetters('ACCOUNT', {
        user: 'GET_USER',
      }),
} ,
mounted(){
  this.getThreadId();
} 
}
</script>

<style lang="scss">
.chat-body{
  //height:  calc(100% - 110px);
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  min-height: 300px;
}
.input-area{
  display: flex;
    justify-items: center;
    align-items: center;
    position: fixed;
    bottom: 0px;
    z-index: 10;
    left: 0px;
    width: 100%;
    padding: 1rem;
}
 
.system-message{
border-radius: 10px 10px 10px 0px;
padding:10px ;
display: inline-block ;
margin-bottom:.5rem;

background-color: var(--v-bg8-base);
margin-left: .1rem;
}
.user-message{
 
border-radius: 10px 10px 0px 10px;
padding:10px ;
display: inline-block;
margin-bottom: .5rem;
background-color: var(--v-colored_bg-base);
justify-self: end;
margin-right: .1rem;
}


.chatbot-modal {
  position: fixed;
  bottom: -100%; // Start hidden
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height :50vh;
  padding:1rem;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.2);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: bottom 0.4s ease;
  // transition: max-height 0.4s ease;
  z-index:100000;
  background-color: var(--v-white1-base);
  // max-height: 50%;
}
.chatbot-modal.open {
  bottom: 0; // Slide up into view
}
.chatbot-modal.max {
  width: 100%;
   height :100vh;
  // // max-height:100vh;
  padding: 1rem;
}
.message-container{
   display: flex;
    align-items: center;
 
}
.send-btn{
  top: -40% !important;
    height: 46px !important;
    top: -33% !important;
    left: 20% !important;
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
}
.input-area  .v-input__append-inner{
height: 37px !important;
}
</style>